import ReactGA from 'react-ga'

if (import.meta.env.MODE !== 'development') {
  ReactGA.initialize(import.meta.env.REACT_APP_GOOGLE_ANALYTICE!)
}

export default ReactGA
